var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-container',[_c('Heading',{attrs:{"size":"small","padded":""}},[_vm._v(_vm._s(_vm.$t('teams.title')))]),_c('p',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.$t('teams.description.open')))]),_c('Teams')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }